export default function PrivacyPage() {
  return (
    <div className="pt-24 pb-20">
      <div className="max-w-3xl mx-auto px-4 prose prose-invert">
        <h1 className="font-display text-4xl font-black">Privacy Policy</h1>
        <p className="text-xs text-slate-500">Last updated: 2026-10-10 · Plain-English template; see your attorney before production use.</p>

        <h2 className="font-display text-2xl font-bold mt-6">What we collect</h2>
        <ul className="text-slate-300 list-disc pl-6">
          <li>Your public wallet address (on-chain, already public).</li>
          <li>Game state tied to your wallet: credits, FLAME, plots, streak, leaderboard rank.</li>
          <li>Transaction hashes you submit for burn & claim verification.</li>
          <li>Approximate IP-based country (used only for geo-blocking; not stored long-term).</li>
          <li>Standard web analytics via PostHog (anonymous event counts).</li>
        </ul>

        <h2 className="font-display text-2xl font-bold mt-6">What we do not collect</h2>
        <ul className="text-slate-300 list-disc pl-6">
          <li>Private keys, seed phrases, or signed transactions beyond what the chain already records.</li>
          <li>Identity documents, government IDs, or KYC data (Phase 1).</li>
          <li>Precise geolocation beyond country code.</li>
        </ul>

        <h2 className="font-display text-2xl font-bold mt-6">How we store it</h2>
        <p className="text-slate-300">Game state is kept in MongoDB keyed by lowercased wallet address. There are no accounts,
          emails or passwords; your wallet is your login. Logs are retained ~30 days.</p>

        <h2 className="font-display text-2xl font-bold mt-6">Your rights</h2>
        <p className="text-slate-300">Email <a href="mailto:ops@flamefarm.app" className="text-cyan-400">ops@flamefarm.app</a> to request
          deletion of your game profile. On-chain data cannot be deleted — it lives on Cronos Mainnet.</p>

        <h2 className="font-display text-2xl font-bold mt-6">Cookies</h2>
        <p className="text-slate-300">We use localStorage for the 18+ age confirmation. PostHog may set a session cookie for anonymous
          analytics. No ad-tracking cookies.</p>

        <h2 className="font-display text-2xl font-bold mt-6">Contact</h2>
        <p className="text-slate-300">Privacy questions: <a href="mailto:privacy@flamefarm.app" className="text-cyan-400">privacy@flamefarm.app</a>.</p>
      </div>
    </div>
  );
}
